import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingBookButton from "@/components/FloatingBookButton";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import ReviewPage from "@/pages/ReviewPage";
import AdminPage from "@/pages/AdminPage";

function AppShell() {
  const location = useLocation();
  const bare = location.pathname === "/review" || location.pathname === "/admin";
  return (
    <>
      {!bare && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/review" element={<ReviewPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      {!bare && <Footer />}
      {!bare && <FloatingBookButton />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0E17] text-[#F5F1E8]">
      <BrowserRouter>
        <AppShell />
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            classNames: {
              toast: "!bg-[#111827] !border-white/10 !text-[#F5F1E8]",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
